// extracted by mini-css-extract-plugin
module.exports = {"name":"styles-module__name___3T41O"};